/**
 * Created By caoyu at 2020-05-25
 * 易迅呼叫中心
 */
import Base64  from 'base-64';
import {YiXunGetToken} from "@/api/CallCenter";
import LoginUserHelper from "@/util/LoginUserHelper";
// 易迅websocket
const YiXunSeatsId = JSON.parse(localStorage.getItem("CRM_CALLCENTER_INFO") || "{}").agentNo; // 分机坐席号

// 获取易迅token
export const getYiXunToken = () => {
    return new Promise((resolve, reject) => {
        // const YiXunToken = getCookie("YiXunToken") || null
        // if (!YiXunToken) {
            // 获取cookie
            YiXunGetToken().then(ret => {
                if (ret.code === 0) {
                    const Token = ret.data
                    // setCookie("YiXunToken", Token,1)
                    resolve(Token)
                } else {
                    reject(ret)
                }
            })
        // } else {
        //     resolve(YiXunToken)
        // }
    })
}
// 打开多页面引起的WebSocket断线重连
export const loadWebSocket = () => {
    return new Promise(((resolve, reject) => {
        if (window.loadYiXunSDK) {
            window.loadYiXunSDK("reconnect").then(ret => {
                resolve(true)
            })
        } else {
            resolve(true)
        }
    }))
}
// 注册
export const YiXunDoLogin = () => {
    return new Promise(((resolve, reject) => {
        getYiXunToken().then(token => {
            window.YiXunSocket.send(`doLogin_free|${YiXunSeatsId}|${token}`)
            // window.YiXunSocket.send(`doLogin_free|${YiXunSeatsId}|03E91C657270F9567C04ADE19FCEE2C9`)
            resolve(true)
        })
    }))
}
// 取消注册
export const YiXunDoLoginOff = () => {
    window.YiXunSocket.send("doLoginOff")
}
// 获取坐席状态
export const getYiXunAgentStatus = () => {
    return new Promise(((resolve, reject) => {
        loadWebSocket().then(_ => {
            window.YiXunSocket.send(`AgentStatus|${YiXunSeatsId}`)
            resolve(true)
        })
    }))
}
// 迁入
export const YiXunAgentLogin = () => {
    return new Promise(((resolve, reject) => {
        loadWebSocket().then(_ => {
            window.YiXunSocket.send(`AgentCallbackLogin|agent-login|${YiXunSeatsId}|${YiXunSeatsId}`)
            resolve(true)
        })
    }))
}
// 迁出
export const YiXunAgentLogoff = () => {
    return new Promise(((resolve, reject) => {
        loadWebSocket().then(_ => {
            window.YiXunSocket.send(`AgentLogoff|${YiXunSeatsId}`)
            resolve(true)
        })
    }))
}
// 置忙/置闲 status：true 置忙｜false 置闲
export const YiXunQueuePause = (status) => {
    return new Promise(((resolve, reject) => {
        loadWebSocket().then(_ => {
            window.YiXunSocket.send(`QueuePause|${YiXunSeatsId}|${!!status}`)
            resolve(true)
        })
    }))
}
// 外呼
export const YiXunOutbound = (phone) => {
    return new Promise(((resolve, reject) => {
        loadWebSocket().then(_ => {
            window.YiXunSocket.send(`MakeCall|agent|${YiXunSeatsId}|${phone}`)
            resolve({
                code: 0
            })
        })
    }))
}
// 挂断
export const YiXunHangup = () => {
    return new Promise(((resolve, reject) => {
        loadWebSocket().then(_ => {
            window.YiXunSocket.send('Hangup')
            resolve(true)
        })
    }))
}
// 监听
export const YiXunSpyCall = (id) => {
    return new Promise(((resolve, reject) => {
        loadWebSocket().then(_ => {
            window.YiXunSocket.send(`SpyCall|${YiXunSeatsId}|${id}|0`)
            resolve(true)
        })
    }))
}
// 心动检测
export const YiXunHeartBeat = () => {
    window.YiXunSocket.send('HeartBeat')
}
// 拓展字段
export const YiXunCDRextend = (uid, clueGuid) => {
    const UserInfo = LoginUserHelper.getUserInfo(),
      data = Base64.encode(
        `${UserInfo.id}|${clueGuid}|1|${UserInfo.campusId}|${YiXunSeatsId}`
      );
    console.log("拓展参数", `${UserInfo.id}|${clueGuid}|1|${UserInfo.campusId}|${YiXunSeatsId}`)
    window.YiXunSocket.send(`CDRextend|${uid}|${data}`)
}
